export enum ResetTypeEnum {
    HARD = 'HARD',
    SOFT = 'SOFT',
}
